(() => {
  "use strict";

  // Delay execution until page is interactive
  window.addEventListener("load", () => {

    // Lazy-load all images
    document.querySelectorAll("img").forEach(img => {
      if (!img.hasAttribute("loading"))
        img.setAttribute("loading", "lazy");

      if (!img.hasAttribute("decoding"))
        img.setAttribute("decoding", "async");
    });

    // Load deferred scripts
    document.querySelectorAll("script[data-defer-src]").forEach(script => {
      const s = document.createElement("script");
      s.src = script.dataset.deferSrc;
      s.defer = true;
      document.body.appendChild(s);
    });

    // Load idle scripts
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadIdleScripts);
    } else {
      setTimeout(loadIdleScripts, 2000);
    }
  });

  function loadIdleScripts() {
    document.querySelectorAll("[data-idle-import]").forEach(el => {
      import(el.dataset.idleImport).catch(()=>{});
    });
  }

  // Lazy initialize sections
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const target = entry.target;

      if (target.dataset.lazyScript) {
        import(target.dataset.lazyScript).catch(()=>{});
      }

      observer.unobserve(target);
    });
  });

  document.querySelectorAll("[data-lazy-script]").forEach(el => {
    observer.observe(el);
  });

})();